<div class="console-container">
    <div class="content-align img-container" *ngIf="showIcon"> 
      <img class="img-stype" src="{{ baseHref }}/assets/images/icon-tick.svg"
      alt="warning-icon"/>
    </div>

    <div *ngIf="isUnsubmittedCase == false">
      <div class="content-align msg-align"><p>{{message}}</p></div>
      <div class="content-align">
        <button class="btn-close" (click)="close()">OK</button>
      </div>
    </div>

    <div *ngIf="isUnsubmittedCase == true">
      <div class="info-message"><p>{{message}}</p></div>
      <div class="user-card">
        <div class="user-name">{{name}}</div>
        <div class="user-email">{{email}}</div>
      </div>
      <p class="info-message">
          However, you can view other cases of this user in <strong>Read-Only Mode</strong>.
      </p>
      <div class="content-align-right">
        <button class="btn_Proceed" (click)="close()">Close</button>
        <button class="btn_Proceed" (click)="proceed()">Proceed</button>
      </div>
    </div>
</div>